export const commaSeparatedValToArrOrVal = (val, separator = ',') => {
  if (typeof val !== 'string') return val;

  return val
    .split(separator)
    .filter(item => item.trim().length > 0)
    .map(item => item.trim());
};
